import type { $Fetch } from 'ofetch';
import { BaseClient } from '@shared/clients/BaseClient.ts';
import type {
    EvergladesProductsApiHeaders,
    EvergladesProductsApiQueryParams,
    EvergladesProductsApiSuccess,
    Logger,
} from '@shared/types/types';
import type { AsyncResult, Result } from '@shared/types/utilities';
import type { SelectionEvents } from '@tilelist/application/ports/SelectionEvents.ts';

const DEFAULT_TIMEOUT_MS = 1800;

export class EvergladesClient extends BaseClient {
    constructor({
        baseURL,
        fetchClient,
        logger,
        selectionEvents,
        timeout = DEFAULT_TIMEOUT_MS,
    }: {
        fetchClient: $Fetch;
        logger: Logger;
        selectionEvents?: SelectionEvents;
        baseURL?: string;
        timeout?: number;
    }) {
        super(baseURL, fetchClient, logger, timeout);
        this.selectionEvents = selectionEvents;
    }

    private readonly selectionEvents?: SelectionEvents;

    async getProducts(
        query: EvergladesProductsApiQueryParams,
        headers?: EvergladesProductsApiHeaders,
    ): AsyncResult<EvergladesProductsApiSuccess> {
        try {
            const payload = await this.fetch<EvergladesProductsApiSuccess>('/everglades/products', {
                query,
                headers: {
                    ...(headers ?? {}),
                    accept: 'application/json',
                    ...(this.selectionEvents
                        ? { 'x-entry-selection-rule': this.selectionEvents.current().entryRule }
                        : {}),
                },
            });

            return { state: 'success', payload } satisfies Result<EvergladesProductsApiSuccess>;
        } catch (_err: unknown) {
            return {
                state: 'error',
            } satisfies Result<EvergladesProductsApiSuccess>;
        }
    }
}
